// Locale strings of report 2.3 (cash-flow-statement), accountant's document 2026-10-03.
// Merged ONCE into finance.reports2.<camelCaseSlug> by ./index.js: use
// $t("finance.reports2.<camelCaseSlug>.<key>"). Owned by this report only.
export default {
  pageTitle: "قائمة التدفقات النقدية (الطريقة غير المباشرة)",
  title: "قائمة التدفقات النقدية (الطريقة غير المباشرة)",
  item: "البند",
  linkedAccounts: "الحسابات المرتبطة",
  openingBalance: "رصيد بداية الفترة",
  closingBalance: "رصيد نهاية الفترة",
  change: "التغير",
  cashEffect: "الأثر النقدي",
  nonCashOffset: "مقابل البنود غير النقدية",
  netProfitBeforeTax: "صافي الربح قبل الضريبة",
  revenue: "الإيرادات",
  expenses: "المصاريف",
  incomeTax: "ضريبة الدخل",
  profitAfterTax: "صافي الربح بعد الضريبة",
  netChange: "صافي التغير في النقدية",
  openingCash: "النقدية بداية الفترة",
  closingCash: "النقدية نهاية الفترة (محتسبة)",
  actualClosingCash: "النقدية الفعلية",
  fxDifference: "فروق تحويل العملات",
  unclassified: "حركات حسابات غير مصنّفة في القائمة",
  controlDifference: "فرق الرقابة",
  reconciled: "مطابقة للنقدية الفعلية",
  notReconciled: "غير مطابقة للنقدية الفعلية",
  cashControlTitle: "التحقق النهائي من توازن النقدية (الرقابة)",
  cashControlHint: "رصيد النقدية النهائي (الصناديق + البنوك + بوابات الدفع) يجب أن يطابق نهاية قائمة التدفقات النقدية.",
  baseSummaryTitle: "الملخص بالعملة الأساسية",
  rate: "سعر التحويل",
  currencySection: "القسم بعملة",
  warnings: "تنبيهات",
  notes: "ملاحظات",
  notesTitle: "تفاصيل هامة",
  alert: "ملاحظة",
  addBack: "بند غير نقدي (يُستبعد من صافي الربح)",
  missingCodes: "رموز غير موجودة",
  unclassifiedHint: "الحسابات التالية تحركت خلال الفترة وليست ضمن بنود القائمة:",
  statementSheet: "قائمة التدفقات",
  cashSheet: "رقابة النقدية",
  summarySheet: "الملخص بالعملة الأساسية",
  noAccounts: "لا توجد حسابات متحركة في هذا البند",
  csv: "CSV",
  excel: "Excel",
  periodRequired: "يرجى تحديد بداية الفترة ونهايتها",
};
